import React from 'react';
import styles from "./styles";
import axios from 'axios'
import axiosConfig from '../../../../config/axios.config'

const ContactDisplay = (props) => {
  const {data, index, type, id} = props;

  return <div key={index} style={{display: 'inline-block', marginRight: 8}}>
    <p style={styles.ctmsP}><b>Contact</b></p>
      {data.name && <p style={styles.ctmsP}><b>Name</b> {data.name}</p>}
      {data.email && <p style={styles.ctmsP}><b>Email</b> {data.email}</p>}
      {data.phone && <p style={styles.ctmsP}><b>Phone</b> {data.phone}</p>}
  </div>
}

export default ContactDisplay;
